import React from 'react';
import { Box, Card, Grid, Stack, Typography, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import rxIcon from '../../../assets/platform/icons/tags/rx.svg'
import SVGIcon from '../../images/SVGIcon';
import OrderedProduct from '../products/OrderedProduct';
import { grey } from '@mui/material/colors';
import RefrigeratedOrderStatus from '../products/RefrigeratedOrderStatus';
import SvgColor from '../../svg-color';
const ProductsContainer = (props) => {

    const {line_items} = props
    const classes = useStyles()
    const theme = useTheme()

    let require_recipe = false
    let retains_recipe = false
    let is_refrigerated = false

    line_items.forEach(item => {
        if(item.requires_recipe === 1) require_recipe = true
        if(item.retains_recipe === 1) retains_recipe = true
        if(item.refrigerated === 1) is_refrigerated = true
    })

    return ( 
        <div>
            <Grid container>
                {line_items.map(item => {
                    return(
                        <Grid item xs={12}>
                            <Box sx={{
                                borderBottom:`1px solid ${grey[100]}`,
                                py:2
                            }}>
                                <OrderedProduct product={{...item}} size='small'/>
                            </Box>
                        </Grid>
                    )
                })}
                
            </Grid>
            <Stack alignItems='center' spacing={1} sx={{mt:2}}>
                    {!!require_recipe && (
                        <div >
                            <Grid container justifyContent='center' alignItems='center' wrap='nowrap'>
                                <Grid item>
                                    <Stack sx={{height:18}} justifyContent='center' alignItems='center'>
                                        <SvgColor src="/assets/images/icons/tags/rx.svg"  color={theme => theme.palette.accent.main} />
                                    </Stack>
                                </Grid>
                                <Grid item>
                                    <Typography 
                                    variant='body2'
                                    sx={{
                                        color: theme => theme.palette.accent.main
                                    }}>Se requiere receta en este pedido</Typography>
                                </Grid>
                            </Grid>
                        </div>
                    )}
                    {!!retains_recipe && (
                        <div >
                            <Grid container justifyContent='center' alignItems='center' wrap='nowrap'>
                                <Grid item>
                                    <Stack sx={{height:18}} justifyContent='center' alignItems='center'>
                                        <SvgColor src="/assets/images/icons/tags/rx.svg"  color={theme => theme.palette.accent.main} />
                                    </Stack>
                                </Grid>
                                <Grid item>
                                    <Typography 
                                    variant='body2'
                                    sx={{
                                        color: theme => theme.palette.accent.main
                                    }}>Se retiene receta en esta compra</Typography>
                                </Grid>
                            </Grid>
                        </div>
                    )}
                    {is_refrigerated && <RefrigeratedOrderStatus />}
                </Stack>
        </div>
     );
}

const useStyles = makeStyles(theme => ({
    recipe_text:{
        color:theme.palette.secondary.main,
        fontSize:16
    },
    recipe_wrapper:{
        padding:12
    }
}))
 
export default ProductsContainer;